import { LOANS_MODAL_STATES } from 'loans.module/common/domain/constants.loans';

class MyLoansModalController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.modalStates = LOANS_MODAL_STATES;
  }

  getModalShow(modalToShow) {
    return this.optionIsSelected === modalToShow;
  }

  changeStateCadastral($event) {
    this.stateCadastral = $event.stateCadastral;
    this.optionIsSelected = '';
  }

  onCloseModalCadastral($event) {
    this.closeModalCadastral(this.EventEmitter($event));
  }
}

export default MyLoansModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/myLoansModal/myLoansModal.controller.js